import * as React from 'react'

import MUIStepper from '@mui/material/Stepper'

const Stepper = (props) => <MUIStepper {...props} />

export default Stepper
